import compose from 'ramda/src/compose';
import bind from 'ramda/src/bind';
import { minWidth, maxWidth } from './media';

const matchMedia = bind(window.matchMedia, window);

export const up = compose(
	matchMedia,
	minWidth
);

export const down = compose(
	matchMedia,
	maxWidth
);
